// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class AlarmUriDocument_abstract extends PersistentObject {
  static $t: string = 'SagaSchema.AlarmUriDocument';
  $t: string = 'SagaSchema.AlarmUriDocument';

  public static GetMembers(): string[] {
    return ['Id', 'FileUId', 'UriName', 'Title', 'SortOrder', 'Deleted'].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return AlarmUriDocument_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public Id: Guid = GuidTools.Empty;
  public FileUId: Guid = GuidTools.Empty;
  public UriName: string;
  public Title: string;
  public SortOrder: number = 0;
  public Deleted: boolean = false;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ObjId(): any {
    return this.Id;
  }
  get ParentObjId(): any {
    return this.FileUId;
  }
  set ParentObjId(value: any) {
    this.FileUId = value;
  }

  /*</AUTO_IMPLEMENTATION>*/
}
